var render = function render(){var _vm=this,_c=_vm._self._c;return _c('article',{staticClass:"content appBox",attrs:{"id":"content"}},[_c('keep-alive',[(_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e()],1),(!_vm.$route.meta || !_vm.$route.meta.keepAlive)?_c('router-view'):_vm._e(),_c('commen-foot',{attrs:{"id":"foot"}}),_c('ICP')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }